/**
 * Payment channel values
 */
export enum PaymentChannelEnum {
	IN_PERSON = 'in_person',
	IN_APP = 'in_app',
	EMAIL = 'email',
	POS = 'pos',
	OTHER = 'other',
}
